import { Pregunta } from './pregunta';

export class Patron {
    idPatron: string; // idPatron
    textoPatron: string; // textoPatron
    tipoPatron: string; // tipoPatron
    fechaCumplimentacion: string;
    // preguntas: Pregunta[]; // nulo cuando viene el listado
    patronesHijo: Patron[]; // nulo cuando viene el listado
    agrupaciones: any[];  // agrupacion de preguntas por grupo
    descripcionPatron: string;
}



// WEBPACK FOOTER //
// ./src/models/patron.ts